import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P78-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page78/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page78/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P78-E2',
    audio: 'img/FriendsPlus/Page78/Audio/audio-e2-p78.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page78/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page78/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page78/Audio/tieude-e2-p78.mp3' },
        { url: 'img/FriendsPlus/Page78/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page78/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P78-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page78/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read again. Circle the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', padding: 3 },
        limitSelect: 1,
        listWords: [
          'zoo / farm / store.', //0
          'plum / mango / apple', //1
          'nine / eight / three', //2
          'coats / sun_hats / T-shirts.', //3
          'drinks / books / toys.', //4
        ],
        answers: ['0-4', '1-4', '2-0', '3-4', '4-0'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page78/E3/1.jpg" style="width: 100%">
        <div style='display: flex; flex-direction: row;position: relative;'>
          <div style='flex: 3'>
            <div><b>1</b>&nbsp;The school trip is on <span style='font-weight: bold;'>Monday / Tuesday / <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">Wednesday.</span></span></div>
            <div><b>2</b>The trip is to a <input id='0' type='Circle' /></div>
            <div><b>3</b>There are <input id='1' type='Circle' /> trees.</div>
            <div><b>4</b>They go to the farm at <input id='2' type='Circle' /> o’clock.</div>
            <div><b>5</b>They can wear <input id='3' type='Circle' /></div>
            <div><b>6</b>They can bring <input id='4' type='Circle' /></div>
          </div>
        </div>
      `,
    },
  },
}

export default json;